import { useMutation } from "@apollo/client";
import {
  CreateInviteMutation,
  CreateInviteMutationVariables,
} from "gql/graphql";
import CREATE_INVITE_MUTATION from "./_networking/create-invite-mutation";

const useInvite = () => {
  const [createInviteAPI] = useMutation<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >(CREATE_INVITE_MUTATION);

  return {
    createInviteAPI,
  };
};

export default useInvite;
